import { GetPartnersRequestApiResponse } from "../types/api";
import { GetPartnersRequestResponse } from "../types/domain";

export const transformToGetPartnersRequest = (response: GetPartnersRequestApiResponse): GetPartnersRequestResponse =>
  response;
